// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"x7-z"};